import Certify1 from "@/assets/certificationsRouter/certificationsFile/111/2021_CySecSpecialist_Components.pdf";
import Certify2 from "@/assets/certificationsRouter/certificationsFile/111/20220812175218Certificate.pdf";
import Certify3 from "@/assets/certificationsRouter/certificationsFile/111/20220812175220Certificate.pdf";
import Certify4 from "@/assets/certificationsRouter/certificationsFile/111/20220812175749Certificate.pdf";
import Certify5 from "@/assets/certificationsRouter/certificationsFile/111/20220812175756Certificate.pdf";
import Certify6 from "@/assets/certificationsRouter/certificationsFile/111/DeepLearningInstitute-DUKE.pdf";
import Certify7 from "@/assets/certificationsRouter/certificationsFile/111/DUKE_AFTEREFFECT.pdf";
import Certify8 from "@/assets/certificationsRouter/certificationsFile/111/DUKE_AUTOCAD.pdf";
import Certify9 from "@/assets/certificationsRouter/certificationsFile/111/DUKE_DATAPOWER.pdf";
import Certify10 from "@/assets/certificationsRouter/certificationsFile/111/DUKE_ML.pdf";
import Certify11 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify12 from "@/assets/certificationsRouter/certificationsFile/111/CCNA_200-125_CISCO_429011205263JODH_20170615.pdf";
import Certify13 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify14 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify15 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify16 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify17 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify18 from "@/assets/certificationsRouter/certificationsFile/111/OCPJP7_Oracle Certified Professional, Java SE 7 Programmer_219907858OCPJSE7.pdf";
import Certify19 from "@/assets/certificationsRouter/certificationsFile/111/OCPJP6_Oracle Certified Professional, Java SE 6 Programmer_219907858OCPJSE6P.pdf";
import Certify20 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify21 from "@/assets/certificationsRouter/certificationsFile/111/Building Video AI Applications at the Edge on Jetson Nano_NVIDIA Deep Learning Institute_20220113.pdf";
import Certify22 from "@/assets/certificationsRouter/certificationsFile/111/Microsoft CertifiedAzure AI Fundamentals_Microsoft_H913-8282_20210730.pdf";
import Certify23 from "@/assets/certificationsRouter/certificationsFile/111/Adobe Premiere CC_Silicon Stone Education_20210720.pdf";
import Certify24 from "@/assets/certificationsRouter/certificationsFile/111/Adobe InDesign CC_Silicon Stone Education_20210803.pdf";
import Certify25 from "@/assets/certificationsRouter/certificationsFile/111/Getting Started With DeepStream For Video On Jetson Nano_NVIDIA Deep Learning Institute_20210705.pdf";
import Certify26 from "@/assets/certificationsRouter/certificationsFile/111/Getting Started With AI On Jetson Nano_NVIDIA Deep Learning Institute_20201014.pdf";
import Certify27 from "@/assets/certificationsRouter/certificationsFile/111/Artificial Intelligence Knowledge Today_Silicon Stone Education_2019-10-02.pdf";
import Certify28 from "@/assets/certificationsRouter/certificationsFile/111/Artificial Intelligence Essentials_Silicon Stone Education_2019-10-02.pdf";
import Certify29 from "@/assets/certificationsRouter/certificationsFile/111/Big Data DatabaseNoSQL_Silicon Stone Education_2019-10-02.pdf";
import Certify30 from "@/assets/certificationsRouter/certificationsFile/111/Data Analysis Using Excel_Silicon Stone Education_2019-10-05.pdf";
import Certify31 from "@/assets/certificationsRouter/certificationsFile/111/Web Design Using HTML5_Silicon Stone Education_2019-10-04.pdf";
import Certify32 from "@/assets/certificationsRouter/certificationsFile/111/Big Data Knowledge Today_Silicon Stone Education_20180718.pdf";
import Certify33 from "@/assets/certificationsRouter/certificationsFile/111/Python Language Today_Silicon Stone Education_20180718.pdf";
import Certify34 from "@/assets/certificationsRouter/certificationsFile/111/C Language Today_Silicon Stone Education_20180718.pdf";
import Certify35 from "@/assets/certificationsRouter/certificationsFile/111/R Language Today_Silicon Stone Education_20181122.pdf";
import Certify36 from "@/assets/certificationsRouter/certificationsFile/111/Java Language Today_Silicon Stone Education_20180911.pdf";
import Certify37 from "@/assets/certificationsRouter/certificationsFile/111/User Interface Design_Silicon Stone Education_20200905.jpg";
import Certify38 from "@/assets/certificationsRouter/certificationsFile/111/Big Data Infrastructure Hadoop_Silicon Stone Education_20200908.jpg";
import Certify39 from "@/assets/certificationsRouter/certificationsFile/111/Adobe Dreamweaver CC_Silicon Stone Education_20200324.jpg";
import Certify40 from "@/assets/certificationsRouter/certificationsFile/111/SAS Knowledge Today_Silicon Stone Education_20200905.jpg";
import Certify41 from "@/assets/certificationsRouter/certificationsFile/111/Linux Knowledge Today_Silicon Stone Education_20200905.jpg";
import Certify42 from "@/assets/certificationsRouter/certificationsFile/111/Cinema 4D Essential_Silicon Stone Education_20200906.jpg";
import Certify43 from "@/assets/certificationsRouter/certificationsFile/111/CSS3 Knowledge Today_Silicon Stone Education_20200906.jpg";
import Certify44 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify45 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify46 from "@/assets/certificationsRouter/certificationsFile/111/CIW Web Security Associate_CIW Certified Internet Web Professional_20170331.pdf";
import Certify47 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify48 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify49 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify50 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify51 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify52 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify53 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify54 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify55 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify56 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify57 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify58 from "@/assets/certificationsRouter/certificationsFile/111/Prof.VocabularyQuotient Credential-ICT-Expert-Tier Five_GLAD_20141017.pdf";
import Certify59 from "@/assets/certificationsRouter/certificationsFile/111/Barista_Silicon Stone Education_20141029.pdf";
import Certify60 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify61 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify62 from "@/assets/certificationsRouter/certificationsFile/111/Adobe Photoshop CC_Silicon Stone Education_20170222.pdf";
import Certify63 from "@/assets/certificationsRouter/certificationsFile/111/Adobe Illustrator CC_Silicon Stone Education_20170222.pdf";
import Certify64 from "@/assets/certificationsRouter/certificationsFile/111/Designing 3D Animation Games Using 3D Studio Max_Silicon Stone Education_20170222.pdf";
import Certify65 from "@/assets/certificationsRouter/certificationsFile/111/Designing 3D Animation Games Using Maya_Silicon Stone Education_20170222.pdf";
import Certify66 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify67 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify68 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify69 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify70 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify71 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify72 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify73 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify74 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify75 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify76 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify77 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify78 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify79 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify80 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify81 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify82 from "@/assets/certificationsRouter/certificationsFile/111/MCTMicrosoft Certified Trainer_H589-2317_20201201.pdf";
import Certify83 from "@/assets/certificationsRouter/certificationsFile/111/MCEMicrosoft Technology Literacy for Educators_ICT_Exam 62-193_E782-2200.pdf";
import Certify84 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify85 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify86 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify87 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify88 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify89 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify90 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify91 from "@/assets/certificationsRouter/certificationsFile/111/MCSA Office 365_Microsoft Certified Solutions Associate_F111-1705.pdf";
import Certify92 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify93 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify94 from "@/assets/certificationsRouter/certificationsFile/111/MS Programming in c-Sharp_Exam 483_F063-2649.pdf";
import Certify95 from "@/assets/certificationsRouter/certificationsFile/111/MTA Cloud Fundamentals_98-369_F224-83028298419.pdf";
import Certify96 from "@/assets/certificationsRouter/certificationsFile/111/MTA Mobility and Device Fundamentals_98-368_F189-59048298419.pdf";
import Certify97 from "@/assets/certificationsRouter/certificationsFile/111/MTA Software Testing Fundamental_98-379_E804-25788298419.pdf";
import Certify98 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify99 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify100 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify101 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify102 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify103 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify104 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify105 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify106 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify107 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify108 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify109 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify110 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify111 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify112 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify113 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify114 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify115 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify116 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify117 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify118 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify119 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify120 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify121 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify122 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify123 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify124 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify125 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify126 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify127 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify128 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify129 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify130 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Specialist – Network, Infrastructure_1A8BA88A.pdf";
import Certify131 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Specialist – Linux, Configuring_1E8CA66A.pdf";
import Certify132 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Specialist – Essential of HTML5 Programming_1E8CE77F.pdf";
import Certify133 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Specialist – BIG Data, Configuring_1142018.pdf";
import Certify134 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Professional – Human-Computer Interface Design_168A7887.pdf";
import Certify135 from "@/assets/certificationsRouter/certificationsFile/111/Microsys Solution Certified Specialist – BIG Data_320020.pdf";
import Certify136 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify137 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify138 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify139 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify140 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify141 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify142 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify143 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify144 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify145 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify146 from "@/assets/certificationsRouter/certificationsFile/111/test.png";
import Certify147 from "@/assets/certificationsRouter/certificationsFile/111/Cert_1131500355.jpg";
import Certify148 from "@/assets/certificationsRouter/certificationsFile/111/test.png";

var certifications_111 = [
  Certify1,
  Certify2,
  Certify3,
  Certify4,
  Certify5,
  Certify6,
  Certify7,
  Certify8,
  Certify9,
  Certify10,
  Certify11,
  Certify12,
  Certify13,
  Certify14,
  Certify15,
  Certify16,
  Certify17,
  Certify18,
  Certify19,
  Certify20,
  Certify21,
  Certify22,
  Certify23,
  Certify24,
  Certify25,
  Certify26,
  Certify27,
  Certify28,
  Certify29,
  Certify30,
  Certify31,
  Certify32,
  Certify33,
  Certify34,
  Certify35,
  Certify36,
  Certify37,
  Certify38,
  Certify39,
  Certify40,
  Certify41,
  Certify42,
  Certify43,
  Certify44,
  Certify45,
  Certify46,
  Certify47,
  Certify48,
  Certify49,
  Certify50,
  Certify51,
  Certify52,
  Certify53,
  Certify54,
  Certify55,
  Certify56,
  Certify57,
  Certify58,
  Certify59,
  Certify60,
  Certify61,
  Certify62,
  Certify63,
  Certify64,
  Certify65,
  Certify66,
  Certify67,
  Certify68,
  Certify69,
  Certify70,
  Certify71,
  Certify72,
  Certify73,
  Certify74,
  Certify75,
  Certify76,
  Certify77,
  Certify78,
  Certify79,
  Certify80,
  Certify81,
  Certify82,
  Certify83,
  Certify84,
  Certify85,
  Certify86,
  Certify87,
  Certify88,
  Certify89,
  Certify90,
  Certify91,
  Certify92,
  Certify93,
  Certify94,
  Certify95,
  Certify96,
  Certify97,
  Certify98,
  Certify99,
  Certify100,
  Certify101,
  Certify102,
  Certify103,
  Certify104,
  Certify105,
  Certify106,
  Certify107,
  Certify108,
  Certify109,
  Certify110,
  Certify111,
  Certify112,
  Certify113,
  Certify114,
  Certify115,
  Certify116,
  Certify117,
  Certify118,
  Certify119,
  Certify120,
  Certify121,
  Certify122,
  Certify123,
  Certify124,
  Certify125,
  Certify126,
  Certify127,
  Certify128,
  Certify129,
  Certify130,
  Certify131,
  Certify132,
  Certify133,
  Certify134,
  Certify135,
  Certify136,
  Certify137,
  Certify138,
  Certify139,
  Certify140,
  Certify141,
  Certify142,
  Certify143,
  Certify144,
  Certify145,
  Certify146,
  Certify147,
  Certify148,
];
export { certifications_111 };
